import { MoneyProto } from "@noom/noom-contracts/noom_contracts/lib/money";
import { Money } from "gql/graphql";

export function convertMoneyProtoToNumber(
  money: MoneyProto | Money
): number | undefined {
  return money && +money.units + (money.nanos ?? 0) / 1e9;
}

export function hasPositiveMoneyValue(money?: MoneyProto | Money): boolean {
  return convertMoneyProtoToNumber(money) > 0;
}

export function convertNumberToMoney(amount, currencyCode) {
  const units = Math.trunc(amount);
  const nanos = Math.round((amount - units) * 1e9);

  const money: MoneyProto = {
    currencyCode,
    units: units.toString(),
    nanos,
  };

  return money;
}
